/**
 * @generated SignedSource<<53dc3f50d83a7d0b763a5f419bf72253>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuDrawerHeader_itemSearch$data = {
  readonly clearAppliedFiltersLinkReference: string | null;
  readonly appliedFilters: ReadonlyArray<{
    readonly canBeDismissed: boolean | null;
  } | null> | null;
  readonly " $fragmentType": "SbRespRefineMenuDrawerHeader_itemSearch";
};
export type SbRespRefineMenuDrawerHeader_itemSearch$key = {
  readonly " $data"?: SbRespRefineMenuDrawerHeader_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuDrawerHeader_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuDrawerHeader_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clearAppliedFiltersLinkReference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "kind": "LinkedField",
      "name": "appliedFilters",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canBeDismissed",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "0c7d37dbacccb275c6b73ecb4d5a33a5";

export default node;
